import { createContext } from "react";

const AssetContext = createContext();

export default AssetContext;
